import { render } from "./EntryChatPanel.vue?vue&type=template&id=3ad880ae&scoped=true"
import script from "./EntryChatPanel.vue?vue&type=script&lang=js"
export * from "./EntryChatPanel.vue?vue&type=script&lang=js"

import "./EntryChatPanel.vue?vue&type=style&index=0&id=3ad880ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad880ae"]])

export default __exports__